import { AlertMessage } from "../component/common/Alert"
import { basePort, headers, setCookie, getJwtFromCookies, getRoleJwt, renderRedirect } from "../module_auth/AuthService"
import { useState, useEffect } from 'react';

export function FindUserId() {
    const [fullname, setFullname] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState("");

    function handleFullname(event) {
        setShowAlert(false)
        setFullname(event.target.value)
    }

    function clickSubmit(event) {
        event.preventDefault();
        const jwtRequest = {
            fullname:fullname,
        }
        fetch(basePort + '/findUserid', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response.json())
                .then(response   => {
                    setMessage(response.validationMessage)
                    setShowAlert(true)
            }).catch(error => console.log(error))
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row mb-5">
                            <div class="col-md-8 col-xl-6 text-center mx-auto">
                                <h2 style={{fontFamily: 'Nanum Gothic'}}>아이디 찾기</h2>
                                <p></p>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6 col-xl-4" style={{width: '600px'}}>
                                <div class="card mb-5">
                                    <div class="card-body d-flex flex-column align-items-center">
                                        <form class="text-center" method="post">
                                            <div class="mb-3"><input class="form-control" type="text" onChange={handleFullname} placeholder="이름"/></div>
                                            <div class="mb-3"><button class="btn btn-primary d-block w-100" onClick={clickSubmit} type="submit">확인</button></div>
                                        </form>
                                        <AlertMessage show={showAlert} msg={message} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}